import React, { useRef, useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import capsuleicon from "../../../assets/Images/icon/capsule_icon.png";
import chewableicon from "../../../assets/Images/icon/chewable_icon.png";
import efficon from "../../../assets/Images/icon/eff_icon.png";
import muthicon from "../../../assets/Images/icon/mouth_icon.png";
import proteeinbar from "../../../assets/Images/icon/protein_bar_icon.png";
import sachetsicon from "../../../assets/Images/icon/sachets_icon.png";
import tableticon from "../../../assets/Images/icon/tablet_icon.png";
import mouthmelticon from "../../../assets/Images/icon/mouth_icon.png";


import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ArrowLeft, ArrowRight, StepForward, Search, X } from "lucide-react";

const BASE_URL = 'https://nutralike.com';

const slugify = (str) =>
  String(str || "").toLowerCase().replace(/[^a-z0-9]/g, "");

const ProductPage_New = () => {
  const swiperRef = useRef(null);
  const [activeCard, setActiveCard] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSections, setFilteredSections] = useState([]);
  const { slug: routeSlug } = useParams();
  const navigate = useNavigate();

  // 🔥 SLIDER DATA with SEO descriptions
  const data = [
    
   
    {
      title: "Effervescent Tablets",
      img: efficon,
      ogImage: `${BASE_URL}/seo/og-effervescent.png`,
      seoTitle: "Effervescent Tablet Manufacturer | Custom Flavours & Private Label ",
      seoDescription: "Nutralike is India's leading effervescent tablet manufacturer-custom flavours, vitamin C, zinc, immunity, and wellness formulations.",
      metaKeywords: "effervescent tablet manufacturer India, effervescent tablet manufacturer India export, private label effervescent tablet manufacturer India, effervescent tablet contract manufacturer India, GMP effervescent tablet manufacturer India, effervescent tablet third party manufacturer India, vitamin C effervescent tablet manufacturer India, zinc effervescent tablet manufacturer India, immunity effervescent tablet manufacturer, multivitamin effervescent tablet India, custom flavour effervescent tablet manufacturer India, effervescent tablet bulk manufacturer India, effervescent supplement exporter India, fizz tablet manufacturer India private label, effervescent nutraceutical manufacturer India, WHO GMP effervescent tablet manufacturer India, best effervescent tablet manufacturer in India for export, private label effervescent tablet manufacturer India for brands, GMP certified effervescent tablet contract manufacturer India, effervescent tablet third party manufacturer Gujarat India, custom effervescent tablet formulation and packaging India, bulk effervescent tablet supplier India for exporters, effervescent vitamin tablet private label manufacturer India, effervescent tablet manufacturer India WHO GMP certified",
      longDescription: "Our effervescent tablets are specially formulated to deliver maximum nutrition with superior absorption. Unlike traditional pills, these tablets dissolve completely in water, creating a refreshing drink that's gentle on the stomach and fast-acting. Each tablet contains precisely measured doses of essential nutrients that are clinically proven to support immune function, boost energy levels, enhance skin health, and promote overall wellness. Perfect for those who have difficulty swallowing pills or want faster nutrient absorption."
    },
    {
      title: "Tablets",
      img: tableticon,
      ogImage: `${BASE_URL}/seo/og-tablet.png`,
      seoTitle: "Tablet Manufacturer | Nutraceutical & Herbal Tablets ",
      seoDescription: "Nutralike manufactures GMP-certified nutraceutical and herbal tablets for private label and formulations built for global supplement brands.",
      metaKeywords: "tablet manufacturer India export, nutraceutical tablet manufacturer India, herbal tablet manufacturer India, private label tablet manufacturer India, tablet contract manufacturer India, GMP tablet manufacturer India, multivitamin tablet manufacturer India, ayurvedic tablet manufacturer India export, herbal nutraceutical tablet manufacturer India, supplement tablet third party manufacturer India, custom tablet formulation manufacturer India, tablet bulk manufacturer India, nutraceutical tablet exporter India, compressed tablet manufacturer India, coated tablet manufacturer India private label, wellness tablet manufacturer India export, private label nutraceutical tablet manufacturer India export, GMP certified herbal tablet manufacturer India, ayurvedic tablet contract manufacturer India, multivitamin tablet third party manufacturer India, custom tablet formulation and packaging India, bulk nutraceutical tablet supplier India, herbal tablet manufacturer Gujarat India export, nutraceutical tablet manufacturer WHO GMP certified, supplement tablet private label manufacturer India, tablet manufacturer India for global supplement brands",
      longDescription: "Our nutritional tablets are produced under stringent quality controls using advanced compression and coating technologies. From single-ingredient formulations to complex multi-nutrient blends, every tablet is engineered for consistent dosing, stability, and bioavailability — making them a trusted choice for daily supplementation across health categories."
    },
    {
      title: "Capsules",
      img: capsuleicon,
      ogImage: `${BASE_URL}/seo/og-capsule.png`,
      seoTitle: "Hard Gelatin Capsule Manufacturer | Custom Nutraceutical Formulations ",
      seoDescription: "Global supplement brands choose Nutralike for hard gelatin capsule manufacturing, GMP-certified facility,export-ready production from India",
      metaKeywords: "hard gelatin capsule manufacturer India, hard gelatin capsule manufacturer India export, private label hard gelatin capsule manufacturer India, hard gelatin capsule contract manufacturer India, GMP hard gelatin capsule manufacturer India, hard gelatin capsule third party manufacturer India, nutraceutical hard gelatin capsule manufacturer India, herbal hard gelatin capsule manufacturer India, vitamin hard gelatin capsule manufacturer India, hard gelatin capsule bulk manufacturer India, hard gelatin capsule exporter India, nutraceutical capsule manufacturer India export, hard gelatin capsule packaging manufacturer India, custom hard gelatin capsule formulation India, hard gelatin capsule supplier India, supplement capsule manufacturer India export, hard gelatin capsule manufacturer Gujarat India, best hard gelatin capsule manufacturer in India for export, private label hard gelatin capsule manufacturer India for brands, GMP certified hard gelatin capsule contract manufacturer India, hard gelatin capsule third party manufacturer Gujarat India, custom hard gelatin capsule formulation and packaging India, bulk hard gelatin capsule supplier India for exporters, herbal nutraceutical hard gelatin capsule manufacturer India, hard gelatin capsule manufacturer India WHO GMP certified, nutraceutical hard gelatin capsule manufacturer for global brands, hard gelatin capsule manufacturer India private label export",
      longDescription: "Our capsule range offers precise delivery of active ingredients with options spanning vegetarian, gelatin, and softgel formats. Each capsule is filled and sealed under controlled conditions to preserve potency and ensure consistent dosing — ideal for sensitive ingredients, oil-based actives, and time-release formulations."
    },
    {
      title: "Sachets",
      img: sachetsicon,
      ogImage: `${BASE_URL}/seo/og-sachets.png`,
      seoTitle: "Nutraceutical Sachet Manufacturer | Single Dose Powder Sachets ",
      seoDescription: "Nutralike manufactures single-dose nutraceutical sachets - vitamins, minerals, protein, and wellness powder sachets - GMP-certified,custom formulated.",
      metaKeywords: "sachet manufacturer India export, nutraceutical sachet manufacturer India, powder sachet manufacturer India, private label sachet manufacturer India, sachet contract manufacturer India, GMP sachet manufacturer India, single dose sachet manufacturer India, vitamin sachet manufacturer India export, protein sachet manufacturer India, wellness powder sachet manufacturer India, supplement sachet third party manufacturer India, custom sachet formulation manufacturer India, sachet packaging manufacturer India, nutraceutical sachet exporter India, herbal powder sachet manufacturer India, sachet bulk manufacturer India export, private label nutraceutical sachet manufacturer India export, GMP certified powder sachet manufacturer India, single dose vitamin sachet manufacturer India export, custom sachet formulation and packaging India, sachet contract manufacturer Gujarat India export, bulk nutraceutical sachet supplier India, supplement sachet third party manufacturer India, sachet manufacturer India for global brands, protein powder sachet private label manufacturer India, nutraceutical sachet manufacturer WHO GMP certified India",
      longDescription: "Our sachet range delivers convenient, pre-measured doses in flexible single-serve packaging. Whether for hydration, energy, recovery, or daily wellness, each sachet is sealed for freshness and designed for fast dissolution — perfect for on-the-go consumption and modern lifestyle needs."
    },
    {
      title: "Powder",
      img: proteeinbar,
      ogImage: `${BASE_URL}/seo/og-proteien_jar.png`,
      seoTitle: "Nutraceutical Powder Manufacturer | Protein & Wellness Powders ",
      seoDescription: "Nutralike manufactures custom nutraceutical powders - protein, vitamins, minerals, herbal, and wellness blends - GMP-certified, private label.",
      metaKeywords: "nutraceutical powder manufacturer India, powder manufacturer India export, protein powder manufacturer India, private label powder manufacturer India, powder contract manufacturer India, GMP powder manufacturer India, whey protein powder manufacturer India export, plant protein powder manufacturer India, herbal powder manufacturer India export, vitamin powder manufacturer India private label, supplement powder third party manufacturer India, custom powder formulation manufacturer India, wellness powder manufacturer India export, bulk powder manufacturer India, nutraceutical powder exporter India, sports nutrition powder manufacturer India, private label protein powder manufacturer India export, GMP certified nutraceutical powder manufacturer India, whey protein powder contract manufacturer India, plant based protein powder manufacturer India export, custom powder formulation and packaging India, bulk nutraceutical powder supplier India for export, supplement powder third party manufacturer Gujarat India, herbal nutraceutical powder manufacturer India WHO GMP, sports nutrition powder private label manufacturer India, nutraceutical powder manufacturer India for global brands",
      longDescription: "Our protein powders are formulated for serious nutrition - featuring high-quality whey isolates, concentrates, and plant-based proteins blended for optimal amino acid profiles. Manufactured under stringent quality protocols, each batch is tested for purity, solubility, and taste, delivering consistent performance for athletes, active lifestyles, and everyday users."
    },
    {
      title: "Mouth Dissolving Sachets",
      img: mouthmelticon,
      ogImage: `${BASE_URL}/seo/og-mouth.png`,
      seoTitle: "Mouth Dissolving Sachet Manufacturer | MDO Sachets ",
      seoDescription: "Nutralike manufactures innovative mouth dissolving sachets-fast-acting, no-water nutraceutical delivery for vitamins, minerals, and wellness formulations.",
      metaKeywords: "mouth dissolving sachet manufacturer India, mouth dissolving sachet manufacturer India export, MDO sachet manufacturer India, oral dissolving sachet manufacturer India, private label mouth dissolving sachet India, GMP mouth dissolving sachet manufacturer India, mouth dissolving strip manufacturer India, oral thin film manufacturer India export, fast dissolving sachet manufacturer India, no water supplement sachet manufacturer India, dissolving vitamin sachet manufacturer India, mouth dissolving nutraceutical manufacturer India, oral dissolving supplement manufacturer India export, mouth dissolving sachet contract manufacturer India, instant dissolving sachet manufacturer India, mouth dissolving sachet third party manufacturer India, private label mouth dissolving sachet manufacturer India export, GMP certified oral dissolving sachet manufacturer India, fast dissolving nutraceutical sachet manufacturer India, mouth dissolving vitamin sachet contract manufacturer India, no water dissolving supplement sachet manufacturer India, custom mouth dissolving sachet formulation India, mouth dissolving sachet manufacturer Gujarat India export, instant dissolving supplement sachet private label India, innovative nutraceutical delivery sachet manufacturer India, mouth dissolving sachet manufacturer India WHO GMP certified",
      longDescription: "Our mouth dissolving sachets are developed for quick dispersion and fast nutrient absorption, offering a convenient and innovative delivery format for modern nutraceutical products. Formulated using advanced flavor masking and instant-dissolve technology, these sachets provide superior taste, portability, and consumer convenience without the need for water. Ideal for immunity boosters, vitamins, herbal blends, energy support, and wellness supplements, each formulation is manufactured under strict quality standards to ensure stability, consistency, and optimal efficacy."
    },

    // Add more products here with their own SEO data
  ];



  // 🔥 TABLE DATA (DYNAMIC CATEGORY READY)
  const tableData = {
    "Effervescent Tablets": [
    {
  category: "Skin Care",
  items: [
    {
      brand: "Glutathione 500 mg + Astaxanthin 4 mg + N-Acetyl L-Cysteine 50 mg + Vitamin C 40 mg",
      form: "Skin Care",
    },
    {
      brand: "Grape Seed Extract 10 mg + Aloe Vera Extract 10 mg + Glutathione 500 mg + Vitamin C 40 mg + Vitamin E 5 mg + Hyaluronic Acid 30 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 600 mg + N-Acetyl L-Cysteine 400 mg + Vitamin C 50 mg + Selenium 40 mcg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + Phyllanthus Emblica Extract 1000 mg + Vitamin C 65 mg + Grape Seed Extract 50 mg + Alpha Lipoic Acid 100 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + Vitamin C 30 mg + Hyaluronic Acid 30 mg + Vitamin E 5 mg + Goji Berry Extract 10 mg + Blueberry Extract 10 mg + Grape Seed Extract 10 mg + Aloe Vera Extract 10 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 600 mg + N-Acetyl L-Cysteine 400 mg + Vitamin C 40 mg + Hyaluronic Acid 30 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + Hyaluronic Acid 25 mg + Vitamin C 40 mg + Grape Seed Extract 10 mg + Acai Berry Extract 8 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 250 mg + Vitamin C 40 mg + Aloe Vera Extract 40 mg + Marine Collagen 1000 mg + Hyaluronic Acid 40 mg + Grape Seed Extract 40 mg + Blueberry Extract 25 mg + Goji Berry Extract 25 mg + Vitamin D3 200 IU + Vitamin E 10 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 600 mg + Vitamin C 65 mg + Vitamin E 10 mg + Zinc 10 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 50 mg + Bilberry Extract 200 mg + Vitamin C 40 mg + Vitamin E 10 mg + Lutein 10 mg + Lycopene 2 mg + Zeaxanthin 4 mg + Selenium 40 mcg + Zinc 12 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + N-Acetyl L-Cysteine 250 mg + Glutamine 250 mg + Glycine 250 mg + Vitamin C 65 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 250 mg + Alpha Lipoic Acid 50 mg + Vitamin C 25 mg + Grape Seed Extract 5 mg + Vitamin E 5 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 600 mg + N-Acetyl L-Cysteine 400 mg + Vitamin C 40 mg + Vitamin E 10 mg + Hyaluronic Acid 5 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 600 mg + Vitamin C 60 mg + Vitamin E 10 mg + N-Acetyl L-Cysteine 100 mg + Hyaluronic Acid 30 mg + Resveratrol 20 mg + Goji Berry Extract 10 mg + Blueberry Extract 10 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + Vitamin C 40 mg + Hyaluronic Acid 30 mg + Vitamin E 5 mg + Lycopene 16 mg + Astaxanthin 2 mg + Selenium 40 mcg + Aloe Vera 30 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + Vitamin C 80 mg + Phyllanthus Emblica Extract 1000 mg + Mulberry Extract 50 mg + Licorice Extract 50 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + N-Acetyl L-Cysteine 100 mg + Vitamin C 40 mg + Grape Seed Extract 50 mg + Aloe Vera Extract 20 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 300 mg + Tomato Extract 300 mg + Collagen 100 mg + Hyaluronic Acid 60 mg + Vitamin C 60 mg + Vitamin A 600 mcg + Vitamin E 10 mg + Vitamin B5 5 mg + Vitamin K 55 mcg + Vitamin B12 1.4 mcg + Vitamin B3 7 mg + Biotin 30 mcg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + L-Cystine 500 mg + Vitamin C 40 mg + Niacinamide 8 mg + Biotin 30 mcg + Zinc 5 mg + Astaxanthin 4 mg + Grape Seed Extract 50 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg + Vitamin C 1000 mg",
      form: "Skin Care",
    }
  ],
},

{
  category: "Immunity Booster",
  items: [
    {
      brand: "Amla Extract 1000 mg + Vitamin C 40 mg + Zinc 10 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Tulsi Extract 30 mg + Vitamin C 40 mg + Zinc 10 mg + Vitamin D3 400 IU",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Zinc 10 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 500 mg + Vitamin C 40 mg + Grape Seed Extract 30 mg + Zinc 12 mg + N-Acetyl L-Cysteine 50 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Vitamin C 65 mg + Zinc 13.2 mg + Citrus Bioflavonoids 150 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 500 mg + Zinc 10 mg + Vitamin C 65 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Zinc 10 mg + Vitamin C 40 mg + Grape Seed Extract 10 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Zinc 10 mg + Selenium 40 mcg + Vitamin D3 400 IU",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Grape Seed Extract 50 mg + Mulberry Extract 50 mg + Zinc 10 mg + Licorice Extract 50 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Grape Seed Extract 10 mg + Mulberry Extract 10 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Mulberry Extract 10 mg + Acai Berry Extract 10 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Zinc 10 mg + Citrus Bioflavonoids 150 mg + Vitamin D3 600 IU",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1300 mg + Zinc 10 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Sesbania Extract 100 mg + Aloe Vera Extract 50 mg + Biotin 30 mcg + Beta-Carotene 1000 mcg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Zinc 5 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Phyllanthus amarus Extract 500 mg + Zinc 10.8 mg + Vitamin C 35 mg + Citrus Bioflavonoids 100 mg + Giloy Extract 100 mg + Probiotics (5 Billion CFU) + Inulin 20 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Amla Extract 1000 mg + Grape Seed Extract 10 mg",
      form: "Immunity Booster",
    }
  ],
}
,

{
  category: "Onco Care",
  items: [
    {
      brand: "Curcumin Extract 500 mg",
      form: "Onco Care",
    },
    {
      brand: "Curcumin Extract 500 mg + Ginger Extract 15 mg + Black Pepper Extract 2 mg + Zinc 10 mg",
      form: "Onco Care",
    },
    {
      brand: "Curcumin 400 mg + Chamomile Extract 100 mg + Aloe Vera Extract 300 mg + Vitamin C 32.5 mg + Zinc 6.6 mg",
      form: "Onco Care",
    }
  ],
},
{
  category: "Fat Burner",
  items: [
    {
      brand: "L-Carnitine Tartrate 1000 mg",
      form: "Fat Burner",
    },
    {
      brand: "L-Carnitine Tartrate 1200 mg + L-Carnitine 3300 mg",
      form: "Fat Burner",
    },
    {
      brand: "Coffee Extract 400 mg + Wheatgrass Powder 300 mg + Garcinia Cambogia Extract 100 mg + Cinnamon Extract 100 mg + Aloe Vera Extract 50 mg",
      form: "Fat Burner",
    },
    {
      brand: "Garcinia Cambogia 500 mg + Cinnamon Extract 50 mg + Ginger Extract 50 mg",
      form: "Fat Burner",
    },
    {
      brand: "Garcinia Cambogia 500 mg + Green Coffee Bean Extract 100 mg + Ginger Extract 50 mg + Cinnamon Extract 50 mg",
      form: "Fat Burner",
    }
  ],
}
,{
  category: "Diabetic Care",
  items: [
    {
      brand: "Karela Extract 25 mg + Gymnema Extract 100 mg + Alpha Lipoic Acid 300 mg + Folic Acid 176.47 mcg",
      form: "Diabetic Care",
    },
    {
      brand: "Mulberry Leaf Extract 600 mg + Cinnamon Extract 250 mg + Fenugreek Seed Extract 500 mg",
      form: "Diabetic Care",
    },
    {
      brand: "Moringa Leaf Extract 37.5 mg + Karela Extract 50 mg + Jamun Seed Extract 50 mg + Gymnema Leaf Extract 40 mg",
      form: "Diabetic Care",
    }
  ],
}
,
{
  category: "Eye Care",
  items: [
    {
      brand: "Bilberry Extract 200 mg + Vitamin C 40 mg + Glutathione 50 mg + Vitamin E 10 mg + Lutein 10 mg + Lycopene 2 mg + Zeaxanthin 4 mg + Selenium 40 mcg + Zinc 12 mg",
      form: "Eye Care",
    },
    {
      brand: "Mixed Carotenoids 5 mg + L-Glutamic Acid 5 mg + Lutein 4 mg + Resveratrol 2.5 mg + Astaxanthin 2 mg + Copper 1 mg + Selenium 40 mcg",
      form: "Eye Care",
    },
    {
      brand: "Vitamin C 35 mg + Vitamin A 500 mcg + Vitamin D2 200 IU + Vitamin E 10 mg + Zinc 4.5 mg + Lycopene 5 mg",
      form: "Eye Care",
    }
  ],
}
,
{
  category: "Eye Care",
  items: [
    {
      brand: "Bilberry Extract 200 mg + Vitamin C 40 mg + Glutathione 50 mg + Vitamin E 10 mg + Lutein 10 mg + Lycopene 2 mg + Zeaxanthin 4 mg + Selenium 40 mcg + Zinc 12 mg",
      form: "Eye Care",
    },
    {
      brand: "Mixed Carotenoids 5 mg + L-Glutamic Acid 5 mg + Lutein 4 mg + Resveratrol 2.5 mg + Astaxanthin 2 mg + Copper 1 mg + Selenium 40 mcg",
      form: "Eye Care",
    },
    {
      brand: "Vitamin C 35 mg + Vitamin A 500 mcg + Vitamin D2 200 IU + Vitamin E 10 mg + Zinc 4.5 mg + Lycopene 5 mg",
      form: "Eye Care",
    }
  ],
}
,
{
  category: "Sleep Health",
  items: [
    {
      brand: "Melatonin 5 mg + L-Tryptophan 150 mg + Valerian Extract 100 mg + Passion Flower Extract 100 mg + Chamomile Extract 50 mg + Hops Extract 60 mg",
      form: "Sleep Health",
    },
    {
      brand: "Melatonin 5 mg + Jatamansi Extract 5 mg",
      form: "Sleep Health",
    }
  ],
}
,{
  category: "UTI Care",
  items: [
    {
      brand: "D-Mannose 300 mg + Cranberry Extract 200 mg + FOS 25 mg + Probiotics (5 Billion CFU) + Potassium Magnesium Citrate 789 mg",
      form: "UTI Care",
    }
  ],
}
,
{
  category: "Bone Care",
  items: [
    {
      brand: "Calcium Carbonate 625 mg + Vitamin C 40 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium 500 mg + Vitamin D3 400 IU + Zinc 12 mg",
      form: "Bone Care",
    },
    {
      brand: "Multivitamin Blend + Calcium Carbonate 500 mg + Calcium Citrate Malate 100 mg + Magnesium + Selenium",
      form: "Bone Care",
    },
    {
      brand: "Calcium 500 mg + Magnesium 6.3 mg + Zinc 10 mg + Manganese 0.2 mg + Folic Acid 200 mcg + Vitamin D3 200 IU",
      form: "Bone Care",
    },
    {
      brand: "Calcium Carbonate 327 mg + Calcium Lactate Gluconate 1000 mg + Vitamin D3 400 IU + Vitamin C 80 mg + Vitamin B6 2 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium 600 mg + Zinc 10 mg + Magnesium 20 mg + Vitamin B12 1 mcg + Vitamin D3 400 IU + Vitamin K2-7 30 mcg + Vitamin C 40 mg",
      form: "Bone Care",
    },
    {
      brand: "Glucosamine 750 mg + Chondroitin 200 mg + MSM 500 mg + Vitamin D3 300 IU",
      form: "Bone Care",
    },
    {
      brand: "Calcium Carbonate 300 mg + Vitamin C 75 mg",
      form: "Bone Care",
    },
    {
      brand: "Magnesium Bisglycinate 500 mg + Calcium Carbonate 1000 mg + Zinc 40 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium Aspartate 500 mg + Calcium Orotate 500 mg + Calcitriol 0.25 mcg + Zinc 7.5 mg + Magnesium 50 mg + Vitamin B12 100 mcg + Folic Acid 1.5 mg",
      form: "Bone Care",
    }
  ],
}
,
{
  category: "Pulmo Care",
  items: [
    {
      brand: "N-Acetyl L-Cysteine 600 mg",
      form: "Pulmo Care",
    },
    {
      brand: "N-Acetyl L-Cysteine 600 mg + Vitamin C 65 mg",
      form: "Pulmo Care",
    },
    {
      brand: "Quercetin 100 mg + Boswellia Extract 250 mg + Ginger Extract 100 mg + Fennel Extract 50 mg + Vitamin C 60 mg + Zinc 10 mg + N-Acetyl L-Cysteine 600 mg",
      form: "Pulmo Care",
    },
    {
      brand: "N-Acetyl L-Cysteine 600 mg + Pushkarmool Extract 100 mg + Licorice Extract 50 mg + Piper Longum Extract 7 mg",
      form: "Pulmo Care",
    },
    {
      brand: "N-Acetyl L-Cysteine 600 mg + Curcumin Extract 10 mg",
      form: "Pulmo Care",
    }
  ],
}
,
{
  category: "Hydration",
  items: [
    {
      brand: "Sodium 180 mg + Potassium 77 mg + Magnesium 20 mg + Calcium 12.5 mg + Chloride 122.87 mg + Vitamin C 37.5 mg",
      form: "Hydration",
    },
    {
      brand: "Sodium 222 mg + Vitamin C 65 mg + Potassium 81 mg + Magnesium 23 mg + Calcium 12.5 mg + Chloride 128 mg + Zinc 13.2 mg + Vitamin B6 1 mg",
      form: "Hydration",
    },
    {
      brand: "L-Leucine 100 mg + L-Isoleucine 50 mg + L-Valine 50 mg + Vitamin B3 14 mg + Vitamin B2 0.5 mg + Vitamin B12 0.5 mcg",
      form: "Hydration",
    }
  ],
},
{
  category: "Neuro Care",
  items: [
    {
      brand: "Magnesium 300 mg + Zinc 10 mg + Vitamin A 1000 IU",
      form: "Neuro Care",
    },
    {
      brand: "Magnesium 300 mg + Zinc 10 mg",
      form: "Neuro Care",
    },
    {
      brand: "Magnesium 141 mg",
      form: "Neuro Care",
    },
    {
      brand: "Brahmi Extract 300 mg",
      form: "Neuro Care",
    },
    {
      brand: "Caffeine 100 mg + Taurine 100 mg + Vitamin C 65 mg + L-Theanine 150 mg + Choline 100 mg + Zeaxanthin 1 mg + Black Pepper Extract 5 mg + Vitamin B6 1.9 mg + Vitamin B12 2.2 mcg + Vitamin A 240 mcg",
      form: "Neuro Care",
    }
  ],
}
,
{
  category: "Pre Workout",
  items: [
    {
      brand: "L-Arginine 500 mg + L-Carnitine 1000 mg + Zinc 13.2 mg + Vitamin C 40 mg + Caffeine 50 mg",
      form: "Pre Workout",
    },
    {
      brand: "Zinc 13.2 mg + L-Arginine 1500 mg + L-Citrulline",
      form: "Pre Workout",
    },
    {
      brand: "Vitamin B12 1.1 mcg + Taurine 1000 mg + Caffeine 100 mg + Licorice Extract 50 mg",
      form: "Pre Workout",
    }
  ],
}
,{
  category: "Post Workout",
  items: [
    {
      brand: "L-Leucine 20 mg + L-Isoleucine 10 mg + L-Valine 15 mg + Sodium 180 mg + Potassium 77 mg + Magnesium 50 mg + Calcium 50 mg + Zinc 12 mg + Vitamin C 40 mg + Vitamin B3 10 mg + Vitamin B6 2 mg",
      form: "Post Workout",
    }
  ],
}
,
{
  category: "Liver & Lung Care",
  items: [
    {
      brand: "N-Acetyl L-Cysteine 600 mg + Silymarin 250 mg + Ginger Extract 100 mg + Pushkarmool Extract 100 mg + Black Pepper Extract 10 mg + Zinc 6 mg + Magnesium 40 mg + Curcumin 20 mg + Astaxanthin 4 mg + Ginseng Extract 160 mg + Vitamin C 40 mg + Ginkgo Biloba Extract 120 mg",
      form: "Liver & Lung Care",
    }
  ],
}
,{
  category: "Women Health",
  items: [
    {
      brand: "Vitamin B12 1 mcg + Folic Acid 176.47 mcg",
      form: "Women Health",
    },
    {
      brand: "Myo-Inositol 300 mg + Melatonin 2 mg",
      form: "Women Health",
    },
    {
      brand: "Shatavari Extract 300 mg + Vitamin B12 2.2 mcg + Vitamin C 40 mg + Folic Acid 30 mcg + Vitamin K 45 mcg + L-Tryptophan 50 mg + Chasteberry Extract 200 mg + Cranberry Extract 50 mg",
      form: "Women Health",
    },
    {
      brand: "Shatavari Extract 50 mg + Berberine Extract 50 mg + Spearmint Extract 50 mg + Myo-Inositol 500 mg + Chromium Picolinate 200 mcg + Folic Acid 200 mcg",
      form: "Women Health",
    },
    {
      brand: "Ashoka Extract 100 mg + Shatavari Extract 60 mg + Lodhra Extract 60 mg + Hibiscus Extract 14 mg + Vitamin B6 0.6 mg + Vitamin D 120 IU",
      form: "Women Health",
    }
  ],
}
,
{
  category: "General Health",
  items: [
    {
      brand: "Vitamin C 12 mg + Calcium 180 mg + Iron 6.3 mg + Magnesium 93 mg + Chromium 15 mcg",
      form: "General Health",
    },
    {
      brand: "Iron 20 mg + Vitamin C 40 mg + Zinc 4 mg + Folic Acid 176.47 mcg + Vitamin B12 1 mcg",
      form: "General Health",
    },
    {
      brand: "Iron 30 mg + Folic Acid 200 mcg",
      form: "General Health",
    },
    {
      brand: "L-Arginine 1000 mg",
      form: "General Health",
    },
    {
      brand: "Multivitamin Blend (A, B-Complex, C, D, E + Minerals)",
      form: "General Health",
    }
  ],
}
,{
  category: "Men's Health",
  items: [
    {
      brand: "Advanced Multivitamin with Minerals (A, B-Complex, C, D, E + Zinc + Selenium)",
      form: "Men's Health",
    }
  ],
}
,
{
  category: "Female Health",
  items: [
    {
      brand: "Complete Multivitamin + Electrolytes + Trace Minerals",
      form: "Female Health",
    }
  ],
},

{
  category: "General Health",
  items: [
    {
      brand: "Vitamin A 1000 IU + Vitamin D3 100 IU + Vitamin E 10 mg + Vitamin B1 1.4 mg + Vitamin B2 1.6 mg + Vitamin B6 1.9 mg + Vitamin B12 1 mcg + Folic Acid 176.47 mcg + Vitamin B5 5 mg + Vitamin B3 14 mg + Biotin 30 mcg + Potassium 18.75 mg + Magnesium 25 mg + Zinc 2.5 mg + Selenium 40 mcg + Chromium 23 mcg + Giloy Extract 200 mg + Silymarin Extract 250 mg",
      form: "General Health",
    }
  ],
}
,{
  category: "General Health",
  items: [
    {
      brand: "Vitamin A 1000 IU + Vitamin D3 100 IU + Vitamin E 10 mg + Vitamin B1 1.4 mg + Vitamin B2 1.6 mg + Vitamin B6 1.9 mg + Vitamin B12 1 mcg + Folic Acid 176.47 mcg + Vitamin B5 5 mg + Vitamin B3 14 mg + Biotin 30 mcg + Potassium 18.75 mg + Magnesium 25 mg + Zinc 2.5 mg + Selenium 40 mcg + Chromium 23 mcg + Giloy Extract 200 mg + Silymarin Extract 250 mg",
      form: "General Health",
    }
  ],
}
,{
  category: "Hair Care",
  items: [
    {
      brand: "Biotin 30 mcg + Selenium 40 mcg + Zinc 11 mg + Amino Acid Blend + Vitamin E 5 mg + Aloe Vera Extract 20 mg",
      form: "Hair Care",
    },
    {
      brand: "Advanced Amino Acid Blend + Biotin 30 mcg + Vitamin E 5 mg + Folic Acid 176.47 mcg + Zinc 11 mg + Manganese 4 mg + Copper 1.7 mg + Selenium 40 mcg + Grape Seed Extract 10 mg + Vitamin D3 400 IU",
      form: "Hair Care",
    },
    {
      brand: "Ginseng Extract 90 mg + Nettle Leaf Extract 100 mg + Grape Seed Extract 10 mg + Vitamin C 10 mg + Vitamin E 5 mg + Vitamin D3 400 IU + Biotin 40 mcg + Minerals + Amino Acids",
      form: "Hair Care",
    },
    {
      brand: "Biotin 30 mcg + Selenium 7.5 mcg + Zinc 2.5 mg + Amino Acid Blend + Vitamin E 5 mg",
      form: "Hair Care",
    },
    {
      brand: "Sesbania Extract 500 mg + Bamboo Extract 100 mg + N-Acetyl L-Cysteine 50 mg + L-Lysine 100 mg + Folic Acid 64.7 mcg + Selenium 20 mcg",
      form: "Hair Care",
    }
  ],
}
,{
  category: "Vitality",
  items: [
    {
      brand: "Ashwagandha Extract 500 mg + Safed Musli Extract 100 mg + Gokharu Extract 100 mg + L-Carnitine 50 mg + Zinc 12 mg + Ginseng Extract 100 mg + L-Arginine 500 mg",
      form: "Vitality",
    },
    {
      brand: "L-Arginine 300 mg + L-Carnitine 100 mg + Magnesium 100 mg + Ashwagandha Extract 100 mg + Safed Musli Extract 100 mg + Shatavari Extract 100 mg + Ginseng Extract 90 mg + Gokshura Extract 50 mg + Fenugreek Extract 50 mg + Zinc 12 mg",
      form: "Vitality",
    },
    {
      brand: "L-Arginine 500 mg + L-Carnitine 1000 mg + Zinc 13.2 mg + Vitamin C 40 mg + Caffeine 50 mg",
      form: "Vitality",
    },
    {
      brand: "L-Arginine 500 mg + Ashwagandha Extract 500 mg + Safed Musli Extract 50 mg + Zinc 10 mg + Fenugreek Extract 500 mg",
      form: "Vitality",
    },
    {
      brand: "L-Arginine 1500 mg + Folic Acid 176.47 mcg + Zinc 5 mg",
      form: "Vitality",
    },
    {
      brand: "Green Tea Extract 500 mg + Ginseng Extract 100 mg + Licorice Extract 75 mg",
      form: "Vitality",
    },
    {
      brand: "Ashwagandha Extract 300 mg + Ginseng Extract 100 mg + Vitamin B12 2 mcg",
      form: "Vitality",
    }
  ],
}
],

    "Tablets": [
    {
  category: "Skin Care",
  items: [
    {
      brand: "L-Glutathione 600 mg + N-Acetyl-L-Cysteine 400 mg + Alpha-Lipoic Acid 50 mg + Mulberry Fruit Extract 20 mg + Vitamin E 6 mg",
      form: "Skin Care",
    },
    {
      brand: "Collagen Peptide 350 mg + L-Glutathione 50 mg + Astaxanthin (from Haematococcus pluvialis) 4 mg + Chromium Picolinate 200 mcg + Ellagic Acid 25 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 600 mg + Rose Hip Extract 100 mg + Alpha-Lipoic Acid 50 mg + Vitamin C 40 mg + Grape Seed Extract 25 mg + Lycopene 2 mg",
      form: "Skin Care",
    },
    {
      brand: "Vitamin C 40 mg + Vitamin D3 200 IU + Marine Collagen 1000 mg + L-Glutathione 100 mg + Grape Seed Extract 40 mg + Vaccinium corymbosum (Blueberry) Extract 25 mg + Lycium barbarum (Goji Berry) Extract 25 mg",
      form: "Skin Care",
    },
    {
      brand: "Vitamin C 65 mg + Magnesium 75 mg + Pantothenic Acid 5 mg + Vitamin B3 10 mg + Copper 1.5 mg + Manganese 1 mg + Folic Acid 129.41 mcg + Selenium 40 mcg + lodine 75 mcg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 500 mg + Citrus sinensis (L.) Osbeck Fruit Extract 150 mg + Vitamin B3 14 mg + Zinc 10 mg + Lycopene 10 mg + Lutein 8 mg + Astaxanthin 4 mg",
      form: "Skin Care",
    },
    {
      brand: "Picrorhiza kurroa Leaf Extract 200 mg + Silybum marianum (Silymarin) Extract 250 mg + Ginkgo biloba Leaf Extract 120 mg + Co-Enzyme Q10 60 mg + N-Acetyl L-Cysteine 100 mg + Vitamin C 65 mg + Vitamin B3 14 mg + Vitamin E 10 mg + Pantothenic Acid 5 mg + Vitamin B1 1.8 mg + Vitamin B2 2.4 mg + Vitamin B6 2.4 mg + Folic Acid 129.41 mcg",
      form: "Skin Care",
    },
    {
      brand: "Collagen 1000 mg + Hyaluronic Acid (Sodium Hyaluronate) 50 mg + Vitamin C 60 mg + Biotin 30 mcg + Astaxanthin 4 mg + Alpha-Lipoic Acid 50 mg + Co-Enzyme Q10 60 mg",
      form: "Skin Care",
    },
    {
      brand: "Collagen 1000 mg + Hyaluronic Acid (Sodium Hyaluronate) 50 mg + Vitamin C 60 mg + Biotin 30 mcg + Astaxanthin 4 mg + Alpha-Lipoic Acid 50 mg + Co-Enzyme Q10 60 mg",
      form: "Skin Care",
    },
    {
      brand: "Collagen 1000 mg + Hyaluronic Acid (Sodium Hyaluronate) 50 mg + Vitamin C 60 mg + Biotin 30 mcg + Astaxanthin 4 mg + Alpha-Lipoic Acid 50 mg + Co-Enzyme Q10 60 mg",
      form: "Skin Care",
    },
    {
      brand: "Collagen Peptide 800 mg",
      form: "Skin Care",
    },
    {
      brand: "Beta Carotene 30 mg + Grape Seed Extract 150 mg + Vitamin C 40 mg + Zinc 4 mg + Astaxanthin 4 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 150 mg +N-Acetyl L-Cysteine 100 mg +Alpha-Lipoic acid 50 mg + Vitamin C 40 mg + Rose hips Extract 20 mg + Vitamin B3 8 mg + Astaxanthin 2 mg + Mulberry fruit extract 20 mg",
      form: "Skin Care",
    },
    {
      brand: "Glutathione 500 mg +Rose hips Extract 50 mg +Vitamin C 50 mg +Grape seed Extract 50 mg + Alpha Lipoic acid 50 mg",
      form: "Skin Care",
    },
    {
      brand: "Centella Asiatica 400 mg +Vitamin E 10 mg + Vitamin C 40 mg + Alpha lipoic Acid 50 mg+ Beta-Carotene 40 mg + Zinc 12 mg + Astaxanthin 4 mg + Saffron 25 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 250 mg + Alpha Lipoic Acid 50 mg + Vitamin C 40 mg + Grape Seed Extract 25 mg + Rose hip Extract 25 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 300 mg + N-acetyl L-Cysteine 200 mg + Vitamin C 40 mg + Astaxanthin 2 mg + Alpha lipoic acid 50 mg + Rose hips extract 20 mg + Mulberry fruit extract 20 mg + Vitamin B3 8 mg",
      form: "Skin Care",
    },
    {
      brand: "Phyllanthus Emblica L. Extract (Amla) 960 mg + Vitamin C 40 mg",
      form: "Skin Care",
    },
    {
      brand: "Centella Asiatica 150 mg + Astaxanthin 8 mg + Collagen peptide 1000 mg + Resveratrol 10 mg",
      form: "Skin Care",
    },
    {
      brand: "Lutein 3.2 mg + Glutathione 25 mg + Astaxanthin 2 mg.",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 600 mg +Vitamin C 40 mg +Alpha Lipoic Acid 100 mg + Grape Seed Extract 50 mg + Niacin 14 mg",
      form: "Skin Care",
    },
    {
      brand: "Vitamin C 40 mg +Vitamin A 3330 IU +Vitamin D3 400 IU + Vitamin E 10 mg +Zinc 12 mg + Beta carotene Extract 50 mg + Selenium 20 mcg",
      form: "Skin Care",
    },
    {
      brand: "Beta-Carotene 30 mg + Zinc 12 mg + Selenium 40 mcg + Manganese 2 mg + Copper 1 mg",
      form: "Skin Care",
    },
    {
      brand: "Vitamin C 40 mg + Astaxanthin 4 mg + Collagen Peptide 1000 mg + Biotin 30 mcg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 100 mg + Centella asiatica Extract 400 mg + Curcuma longa Extract 50 mg + Crocus sativus Extract 25 mg + Zinc 13.2 mg + Resveratrol 10 mg + Co-Enzyme Q10 60 mg + Astaxanthin 4 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 250 mg + Alpha-Lipoic Acid 50 mg + Vitamin C 40 mg + Grape Seed Extract 50 mg + Rose Hip Extract 50 mg",
      form: "Skin Care",
    },
    {
      brand: "Vitamin C 13.3 mg + Biotin 5 mcg + Selenium 6 mcg + Marine Collagen 833.30 mg + Hyaluronic Acid 6.66 mg + Resveratrol 3.30 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 600 mg + N-Acetyl-L-Cysteine 400 mg + Astaxanthin 8 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 500 mg + Alpha-Lipoic Acid 100 mg + Grape Seed Extract 100 mg + Lycopene 10 mg + Vitamin C 40 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 600 mg + Vitamin C 40 mg + Alpha-Lipoic Acid 100 mg + Grape Seed Extract 50 mg + Vitamin E 10 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 500 mg + Alpha-Lipoic Acid 50 mg + Vitamin C 40 mg + Grape Seed Extract 25 mg + Rose Hips Extract 25 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 600 mg + N-Acetyl-L-Cysteine 125 mg + Vitamin C 40 mg + Vitamin E 6 mg + Astaxanthin 4 mg",
      form: "Skin Care",
    },
    {
      brand: "Picrorhiza kurroa Extract 100 mg + Ginkgo biloba Leaf Extract 60 mg + L-Phenylalanine 100 mg + L-Tyrosine 50 mg + Alpha-Lipoic Acid 180 mg + Vitamin D3 300 IU + Vitamin B6 1.2 mg + Folic Acid 100 mcg + Vitamin B12 1 mcg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 600 mg + Rose Hips Extract 100 mg + Alpha-Lipoic Acid 50 mg + Vitamin C 40 mg + Grape Seed Extract 25 mg + Lycopene 2 mg",
      form: "Skin Care",
    },
    {
      brand: "L-Glutathione 50 mg + Vitamin C 65 mg + Pinus gerardiana Bark Extract 50 mg + Malpighia emarginata (Acerola) Extract 100 mg + Curcuma longa (Turmeric) Rhizome Extract 50 mg + Zinc 13.2 mg + Co-Enzyme Q10 60 mg",
      form: "Skin Care",
    },
    ],
},

    {
  category: "Bone Care",
  items: [
    {
      brand: "Coral Calcium 500 mg + Magnesium 40 mg + Manganese 1.80 mg + Zinc 7.50 mg + Copper 1 mg + Vitamin D3 250 IU + Boron 250 mcg",
      form: "Bone Care",
    },
    {
      brand: "Calcium Citrate Malate 1000 mg + Vitamin D3 300 IU + Vitamin K2 27.5 mcg + Magnesium 15 mg + Zinc8.5 mg + Boswellia serrata Extract 150 mg",
      form: "Bone Care",
    },
    {
      brand: "Cissus quadrangularis L. (Hadjod) Extract 500 mg + Moringa oleifera Extract 100 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium 300 mg + Magnesium Glycinate 400 mg + Vitamin K2 55 mcg + Vitamin D3 600 IU",
      form: "Bone Care",
    },
    {
      brand: "Magnesium 100 mg + Calcium Carbonate 1000 mg + Zinc 5.00 mg + Vitamin D3 200 IU",
      form: "Bone Care",
    },
    {
      brand: "Calcium 138 mg + Vitamin D3 600 IU + Folic Acid 300 mcg + Vitamin B12 2.2 mcg + Vitamin B6 2 mg + Magnesium 100 mg + Zinc 7.5 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium 60 mg + Potassium 90 mg + Chromium Picolinate 200 mcg + Garcinia cambogiaExtract 500 mg + Piper nigrum Extract 10 mg  ",
      form: "Bone Care",
    },
    {
      brand: "Coral Calcium 225 mg + Vitamin C 40 mg + Zinc 10 mg + Magnesium 10 mg + Vitamin B6 2 mg + Vitamin B2 1.6 mg + Folic Acid 129.41 mcg + Vitamin B1 1.4 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium 500 mg + Fructo-Oligosaccharide 200 mg + Isoflavones 40 mg + Magnesium 12.85 mg + Zinc 10 mg + Manganese 2.5 mg ",
      form: "Bone Care",
    },
    {
      brand: "Calcium 1000 mg + Vitamin D3 400 IU + Vitamin K2-7 50 mcg + Magnesium 50 mg + Zinc 5 mg + Cissus quadrangularis L. (Hadjod) Extract 100 mg",
      form: "Bone Care",
    },
    {
      brand: "Calcium Carbonate 400 mg + Magnesium 90.45 mg + Vitamin D3 300 IU + Zinc 6.60 mg + Vitamin B12 1.1 mcg",
      form: "Bone Care",
    },
    {
      brand: "Calcium 250 mg + Vitamin D3 400 IU + Vitamin K2-7 50 mcg + Magnesium 100 mg + Zinc 12 mg + Boron 1.5 mg + Manganese 2 mg + Copper 1 mg + Vitamin C 40 mg ",
      form: "Bone Care",
    },
    {
      brand: "Undenatured Type II Collagen 20 mg + Chondroin Sulphate 150 mg + Glucosamine Hydrochloride 750 mg + Methylsulfonylmethane (MSM) 500 mg (Serving 2 per day)",
      form: "Bone Care",
    },
    {
      brand: "Undenatured Type II Collagen 40 mg + Boswellia serrata Extract 100 mg + Glucosamine Hydrochloride 1500 mg + Astaxanthin 4 mg )",
      form: "Bone Care",
    },
    {
      brand: "Boswellia serrata Extract 100 mg + Undenatured Type II Collagen 40 mg + Rose Hips Extract 275 mg",
      form: "Bone Care",
    },
    {
      brand: "Coral Calcium 500 mg + Vitamin D3 400 IU + Zinc 10 mg + Magnesium 100 mg",
      form: "Bone Care",
    },
    {
      brand: "Coral Calcium 500 mg + Vitamin D3 400 IU",
      form: "Bone Care",
    },
    {
      brand: "Lutein 10 mg + Zeaxanthin 4 mg + Astaxanthin 2 mg + Grape Seed Extract 50 mg + Bilberry Extract 100 mg + Zinc 12 mg + Manganese 4 mg + Copper 1.7 mg ",
      form: "Bone Care",
    },
    {
      brand: "Grape Seed Extract 25 mg + Lycopene 2 mg + Lutein 3 mg + Vitamin A 1998 IU + Vitamin B1 1.4 mg + Vitamin B2 1.6 mg + Vitamin B6 1.9 mg + Vitamin B12 1 mcg + Folic Acid 129.41 mcg + Zinc 12 mg",
      form: "Bone Care",
    },
    {
      brand: "Lutein 3.2 mg + Glutathione 25 mg + Astaxanthin 2 mg ",
      form: "Bone Care",
    },
    
    
    
    ],
},

    {
  category: "Eye Health",
  items: [
    {
      brand: "Pinus gerardiana Bark Extract 25 mg + Vaccinium myrllus (Bilberry) Extract 80 mg",
      form: "Eye Health",
    },
    {
      brand: "Lutein 10 mg + Vitamin B6 1.9 mg + Zeaxanthin 2 mg + Vitamin E 6.7 mg + Vitamin B12 2.2 mcg + Zinc 13.2 mg + Manganese 4 mg",
      form: "Eye Health",
    },
    {
      brand: "N-Acetyl-L-Cysteine 20 mg + Lutein 10 mg + Melatonin 3 mg + Astaxanthin 2 mg + Zeaxanthin 4 mg",
      form: "Eye Health",
    },
    {
      brand: "Soy Isolate (Glycine max (L.) Merr.) 14 mg + Bilberry Extract 25 mg + Run 25 mg + N-Acetyl-L-Cysteine 25 mg + Vitamin A 300 mcg + Vitamin E 5 mg ",
      form: "Eye Health",
    },
    {
      brand: "Lutein 10 mg + Astaxanthin 4 mg + Zeaxanthin 4 mg + Lycopene 2 mg + Copper 1 mg + Selenium 40 mcg + Zinc 12 mg + Manganese 4 mg",
      form: "Eye Health",
    },
    {
      brand: "Curcuma longa Extract 60 mg + Crocus savus L. (Saffron) Extract 25 mg + Vitamin B12 1 mcg + Vitamin B3 14 mg + Vitamin C 40 mg",
      form: "Eye Health",
    },
    {
      brand: "Vaccinium myrllus (Bilberry) Extract 50 mg + Vitamin E (DL-Alpha Tocopherol) 10 mg + Lutein 10 mg + Astaxanthin 8 mg + Zeaxanthin 2 mg + Zinc 10 mg + Copper 1.7 mg ",
      form: "Eye Health",
    },   
    ],
},

    {
  category: "Fat burner",
  items: [
    {
      brand: "Coffea arabica (Green Coffee Seed) Extract 200 mg + Garcinia cambogia Fruit Extract 300 mg + Camellia sinensis Extract (Green Tea Catechins) 300 mg + Gamma-Linolenic Acid 100 mg + L-Carnine Tartrate 200 mg",
      form: "Fat burner",
    },
    ],
},

  {
  category: "Heart Care",
  items: [
    {
      brand: "Co-Enzyme Q10 120 mg + L-Carnine 300 mg + Choline 1500 mcg + Selenium 40 mcg",
      form: "Heart Care",
    },
    {
      brand: "Co-Enzyme Q10 100 mg + Omega-3 Fay Acids 300 mg + L-Arginine 100 mg + L-Carnine 100 mg",
      form: "Heart Care",
    },
    ],
},

{
  category: "Immunity Booster",
  items: [
    {
      brand: "Phyllanthus emblica L. (Amla) Extract 500 mg + Vitamin C 40 mg + Alpha-Lipoic Acid 50 mg + Beta-Carotene 10 mg + Grape Seed Extract 10 mg ",
      form: "Immunity Booster",
    },
    {
      brand: "Phyllanthus emblica L. (Amla) Extract 1000 mg + Zinc 12 mg + Vitamin C 40 mg + Astaxanthin 4 mg",
      form: "Immunity Booster",
    },
    {
      brand: "Phyllanthus emblica L. Fruit Extract 1000 mg + Zinc 13.2 mg + Citrus Bioflavonoids 150 mg + Vitamin C 65 mg",
      form: "Immunity Booster",
    },

    ],
},

{
  category: "Kidney Health",
  items: [
    {
      brand: "L-Carnosine 200 mg + Ginkgo biloba Extract 60 mg",
      form: "Kidney Health",
    },
    {
      brand: "L-Carnosine 200 mg",
      form: "Kidney Health",
    },
     
    ],
},

{
  category: "Liver Health",
  items: [
    {
      brand: "L-Ornithine 150 mg + Pancrean 75 mg + Silybum marianum Extract (Silymarin) 125 mg + Boerhavia diffusa L. Root Extract 50 mg + Tinospora cordifolia Miers Extract 250 mg",
      form: "Liver Health",
    },
    {
      brand: "Silybum marianum Extract (Silymarin) 125 mg + Phyllanthus emblica L. Extract 150 mg + Curcuminoids (Curcumin Extract) 100 mg + Taraxacum officinale (Dandelion) Extract 100 mg + Camellia sinensis Extract (Green Tea Catechins) 150 mg + N-Acetyl-L-Cysteine 200 mg ",
      form: "Liver Health",
    },
     
    ],
},

{
  category: "Neuro Care",
  items: [
    {
      brand: "Magnesium Bisglycinate 400 mg + L-Carnine L-Tartrate 500 mg",
      form: "Neuro Care",
    },
    {
      brand: "Magnesium Bisglycinate 400 mg",
      form: "Neuro Care",
    },
    {
      brand: "Magnesium 200 mg + Vitex agnus-castus (Chaste Berry) Extract 300 mg + Vitamin B6 2 mg",
      form: "Neuro Care",
    },
    {
      brand: "Magnesium 149.96 mg + Zinc 13.20 mg",
      form: "Neuro Care",
    },
    {
      brand: "Co-Enzyme Q10 100 mg + Omega-3 Fay Acids 150 mg + L-Carnine Tartrate 100 mg + Lycopene 5 mg + Zinc 13.2 mg + Selenium 40 mcg",
      form: "Neuro Care",
    },
     
    ],
},

{
  category: "Onco Care",
  items: [
    {
      brand: "Curcuma longa 1000 mg + Piper nigrum 5 mg",
      form: "Onco Care",
    },
    {
      brand: "Curcumin 125 mg + Piper nigrum 5 mg + Astaxanthin 2 mg",
      form: "Onco Care",
    },
    {
      brand: "Curcuma longa (Curcumin Powder) 125 mg + N-Acetyl-L-Cysteine 100 mg + Resveratrol 25 mg + Vitamin D2 600 IU",
      form: "Onco Care",
    },
    ],
},

{
  category: "Pulmo Care",
  items: [
    {
      brand: "N-Acetyl -Cysteine 600 mg N-Acetyl -Cysteine 600 mg",
      form: "Pulmo Care",
    },

    ],
},

{
  category: "Sleep Health",
  items: [
    {
      brand: "Melatonin 3 mg + L-Tryptophan 200 mg",
      form: "Sleep Health",
    },
    {
      brand: "Melatonin 10 mg",
      form: "Sleep Health",
    },
    {
      brand: "Bacopa monnieri (Brahmi) Whole Plant Extract 300 mg + Melatonin (Derived from Tart Cherry Fruit Extract, 100 mg) 5 mg + Magnesium 16.50 mg",
      form: "Sleep Health",
    },

       ],
},

{
  category: "Thyro Care",
  items: [
    {
      brand: "Vitamin D3 (Lichen Source) 600 IU + L-Tyrosine 250 mg + Vitamin B12 2.2 mcg + Iron 18 mg + Vitamin B6 1.9 mg + Folic Acid 129.41 mcg + Copper 0.7 mg + Selenium 40 mcg",
      form: "Thyro Care",
    },

    ],
},

{
  category: "Weight Management",
  items: [
    {
      brand: "Chromium Picolinate 200 mcg + Garcinia cambogia (Kokum) Extract 500 mg + Piper nigrum Extract 10 mg",
      form: "Weight Management",
    },
    {
      brand: "Garcinia cambogia (Kokum) Extract 500 mg + Black Pepper (Piper nigrum) Extract 10 mg + Calcium 60 mg + Potassium 90 mg + Chromium Picolinate 200 mcg",
      form: "Weight Management",
    },

    ],
},

{
  category: "Women Health",
  items: [
    {
      brand: "Folic Acid 129.41 mcg + Vitamin B12 2.2 mcg + Bion 40 mcg + Vitamin B6 1.9 mg",
      form: "Women Health",
    },
    {
      brand: "Iron 12 mg + Beta vulgaris (Beetroot) Root Extract 25 mg + Zinc 7.5 mg + Vitamin B9 (Folic Acid)129.41 mcg",
      form: "Women Health",
    },
    {
      brand: "Beta vulgaris Root Extract 25 mg + Iron 12 mg + Calcium 75 mg + Folic Acid 129.41 mcg + L-Methionine 50 mg + L-Lysine 25 mg + Vitamin A 600 mcg + Vitamin C 40 mg",
      form: "Women Health",
    },
    {
      brand: "Iron 17 mg + Vitamin B12 1 mcg + Folic Acid 129.41 mcg + Zinc 10 mg",
      form: "Women Health",
    },
    {
      brand: "Iron 29 mg + Folic Acid 129.41 mcg + Zinc 10 mg + Vitamin B12 2.2 mcg",
      form: "Women Health",
    },
    {
      brand: "Vitamin C 65 mg + Iron 29 mg + Zinc 13.2 mg + Folic Acid 129.41 mcg + Vitamin B12 2.2 mcg",
      form: "Women Health",
    },
    {
      brand: "L-Arginine 75 mg + L-Carnine (L-Carnine Tartrate) 75 mg + Co-Enzyme Q10 (Ubiquinol Acetate) 100 mg + Astaxanthin 2 mg + Lycopene 1.25 mg + Choline (Choline Bitartrate) 100 mg + Myo-Inositol 50 mg + Vitamin A 262.5 mcg + Vitamin B1 0.78 mg + Vitamin B2 0.93 mg + Vitamin B3 7 mg + Pantothenic Acid 2.5 mg + Vitamin B6 0.95 mg + Bion 15 mcg",
      form: "Women Health",
    },
    {
      brand: "Soy Isoflavones 60 mg + Vitex agnus-castus Leaf Extract 150 mg + Asparagus densiflorus (Shatavari) Extract 100 mg + Tribulus terrestris (Gokharu) Extract 50 mg + Vitamin A 400 mcg + Vitamin B1 0.85 mg + Vitamin B2 1.20 mg + Vitamin B3 7 mg + Pantothenic Acid 2.50 mg",
      form: "Women Health",
    },
    {
      brand: "Iron 27.38 mg + Vitamin C 65 mg + Folic Acid 100 mcg + Vitamin B12 2.2 mcg",
      form: "Women Health",
    },
    {
      brand: "Myo-Inositol 2 g + Vitamin D3 600 IU + Folic Acid 129.41 mcg",
      form: "Women Health",
    },
    {
      brand: "Myo-Inositol 550 mg + N-Acetyl-L-Cysteine 300 mg + Berberis vulgaris Extract (Berberine) 100 mg + Cinnamomum zeylanicum (Cinnamon) Extract 100 mg + Trigonella foenum-graecum (Fenugreek)Extract 100 mg",
      form: "Women Health",
    },
    ],
},

],
      
    "Capsules": [
    {
  category: "Skin Care",
  items: [
    {
      brand: "L-Glutathione 250 mg + Vitamin C 60 mg",
      form: "Skin Care",
    },

    ],
},
    {
  category: "Hair Care",
  items: [
    {
      brand: "Chondroin Sulphate 300 mg",
      form: "Hair Care",
    },

    ],
},
    {
  category: "Vitality",
  items: [
    {
      brand: "Withania somnifera (L.) extract 250 mg + Tribulus terrestris extract 100 mg + Asparagus adscendens Roxb. 50 mg + Mucuna pruriens 50 mg",
      form: "Vitality",
    },

    ],
},

{
  category: "Gut Health",
  items: [
    {
      brand: "Lactobacillus acidophilus 5 billion spores + Streptococcus thermophilus 5 billion spores + Bifidobacterium longum 5 billion spores + Saccharomyces boulardii 5 billion spores + Fructo-oligosaccharides 100 mg",
      form: "Gut Health",
    },
    {
      brand: "Lactobacillus acidophilus (La-14), Lactobacillus casei (Lc-11), Lactobacillus paracasei (Lpc-37), Lactobacillus plantarum (Lp-115), Lactobacillus rhamnosus (Lr-32), Lactobacillus salivarius (Ls-33), Bifidobacterium breve (Bb-03), Bifidobacterium lacs (Bi-04) + Linum usitassimum seed (flaxseed) powder 20 mg",
      form: "Gut Health",
    },

    ],
},

{
  category: "Onco Care",
  items: [
    {
      brand: "Ultrasol curcumin powder 125 mg + N-Acetyl L-Cysteine 100 mg + Resveratrol 25 mg + Vitamin D2 600 IU",
      form: "Onco Care",
    },

    ],
},

{
  category: "Eye Health",
  items: [
    {
      brand: "Astaxanthin 12 mg + Beta-carotene 30 mg, Zinc 17 mg + Selenium 40 mg + Manganese 2 mg + Copper 1 mg",
      form: "Eye Health",
    },
    {
      brand: "Curcumin (curcuminoids extract) 250 mg + Lutein 6 mg + Zeaxanthin isomers 1.2 mg + Vitamin C (L-ascorbic acid) 65 mg + Zinc 13.2 mg + Vitamin E 10 mg + Vitamin D2 600 IU + Copper 1.7 mg + Selenium 40 mcg",
      form: "Eye Health",  
    },

    ],
},

],

    "Sachets": [
{
  category: "Skin Care",
  items: [
    {
      brand: "Collagen and Hydrolysed Pepdes 7 g + Vitamin C 40 mg + Vitamin E 10 mg + Bion 30 mcg",
      form: "Skin Care",
    },
    {
      brand: "Rose Hip Extract 100 mg + Collagen Pepde 10 g + Vitamin C 40 mg + MSM (Methylsulfonylmethane) 1000 mg",
      form: "Skin Care",
    },
    {
      brand: "Marine Collagen Pepde 5 g + Vitamin C 65 mg + L-Arginine 50 mg + Astaxanthin 4 mg + Hyaluronic Acid 50 mg + N-Acetyl-L-Cysteine 50 mg",
      form: "Skin Care",
    },
    {
      brand: "Collagen Pepde 3 g + Vitamin C 40 mg + Beta-Carotene 100 mg + Bion 30 mcg + Astaxanthin 4 mg",
      form: "Skin Care",
    },

    ],
  },

  {
  category: "Diabetic Care",
  items: [
    {
      brand: "Trigonella foenum-graecum 500 mg",
      form: "Diabetic Care",
    },

    ],
  },

  {
  category: "General Wellness",
  items: [
    {
      brand: "L-Glutamine 10 g + Zinc 3.3 mg + Selenium 36 mcg",
      form: "General Wellness",
    },
    {
      brand: "L-Glutamine 10 mg + Vitamin E 10 mg + Vitamin C 40 mg + Zinc 12 mg + Selenium 40 mcg",
      form: "General Wellness",
    },
    {
      brand: "L-Glutamine 10 mg + Zinc 3.3 mg + Selenium 36 mcg",
      form: "General Wellness",
    },
    {
      brand: "L-Glutamine 10 mg + Vitamin A 1500 IU + Vitamin C 40 mg + Vitamin E 10 mg + Zinc 12 mg",
      form: "General Wellness",
    },
    {
      brand: "Protein 25 g + Dietary Fibre 4.2 g + Tricum savum Bran Powder 42 mg + Medicago sava Extract 42 mg + Aethrospira platensis Dried Powder 84 mg + Moringa oleifera Leaf Powder 84 mg + Spinacia oleracea Leaf Powder 84 mg + Tomato Powder 84 mg + Beta vulgaris Root Extract Powder 84 mg + Curcuma longa Rhizome Powder 21 mg + Garcinia cambogia 42 mg + Withania somnifera 42 mg + Conjugated Linoleic Acid 21 mg + Probioc 5 Billion CFU",
      form: "General Wellness",
    },
    {
      brand: "L-Glutamine 5 g ",
      form: "General Wellness",
    },
    {
      brand: "L-Glutamine 10 mg + Vitamin A 1500 IU + Vitamin C 40 mg + Vitamin E 10 mg",
      form: "General Wellness",
    },
    {
      brand: "Taurine 500 mg + N-Acetyl-L-Cysteine 150 mg + Vitamin B3 12 mg + Vitamin B6 2 mg + Folic Acid 129.41 mcg + Vitamin B12 1 mcg",
      form: "General Wellness",
    },
    {
      brand: "L-Glutamine 20 g + Vitamin E 10 mg + Vitamin C 40 mg + Zinc 12 mg + Selenium 40 mcg",
      form: "General Wellness",
    },

    ],
  },

  {
  category: "Liver Care",
  items: [
    {
      brand: "Zingiber officinale Extract 0.5 g + Curcuma longa Extract 0.5 g + Taurine 0.5 g + L-Arginine 1 g + Andrographis paniculata Extract 100 mg + Withania somnifera (L.) Dunal Extract 150 mg + Glycyrrhiza glabra Extract 150 mg",
      form: "Liver Care",
    },

    ],
  },

  {
  category: "Sports Supplement",
  items: [
    {
      brand: "Whey Protein 6.4 g + Leucine 3.16 g + Isoleucine 1.58 g + Valine 1.58 g",
      form: "Sports Supplement",
    },

    ],
  },
  
  {
  category: "Vitality",
  items: [
    {
      brand: "L-Arginine 5 g + Asparagus adscendens (Musali) Extract 3 g + L-Citrulline 500 mg + Tribulus terrestris Extract 150 mg",
      form: "Vitality",
    },

    ],
  },  

    {
  category: "Women’s Health",
  items: [
    {
      brand: "Myo-Inositol 2 g + Vitamin D3 600 IU + Folic Acid 220 mcg",
      form: "Women’s Health",
    },
    {
      brand: "L-Arginine 3 g + Proanthocyanidins 70 mg",
      form: "Women’s Health",
    },
    {
      brand: "L-Arginine 3 g + Grape Seed Extract (Proanthocyanidins 10%) 60 mg + DHA 50 mg",
      form: "Women’s Health",
    },
    {
      brand: "Arginine 3 g + Grape Seed Extract (Proanthocyanidins) 75 mg",
      form: "Women’s Health",
    },

    ],
  }, 


],

    "Powder": [
{
  category: "Pregnant & Lactang Women Supplements",
  items: [
    {
      brand: "Total Fat - 0.65g + Carbohydrate - 19.5g + Protein - 9g + DHA-24mg + Flaxseed powder-15mg + Vitamins + Minerals",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "Protein-10.37g + Carbohydrate-6.15g + Dietary Fibre-0.60g + Total Fat-1.54g + Vitamins + Minerals + Asparagus racemosus ext-90mg + Saraca Asoca-90mg + Tinospora cordifolia-60mg + Curcumin 95%-30mg + Black Pepper-60mg",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "Whey Protein 80% and skimmed milk powder 35% - 12.30 gm + Carbohydrate - 20.01 gm + Dietary fibre - 0.75 gm + Fat - 0.90 gm + DHA 10% (Veg)-24 mg + Vitamins and Minerals",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "DHA 10%-24mg + GLA-1.35mg + Dietary Fibre-0.75g + Protein 35%-6.9g + Carbohydrate-17.1g + Fats-0.45g + Vitamins + Minerals",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "Protein (Pea protein+ Brown Rice Protein+ Mung Bean Protein) 29 gm + Carbohydrate 2 gm + Fat 3 gm",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "Protein (Pea protein+ Brown Rice Protein+ Mung Bean Protein) 26 gm + Carbohydrate 1.6 gm + Fat 1.8 gm",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "Protein (Pea protein + Brown Rice Protein + Mung Bean Protein) 26 gm + Withania somnifera L.Extract + Phyllanthus emblica L. + Glycyrrhiza glabra - Extract + Ocimum sanctum - Extract ",
      form: "Pregnant & Lactang Women Supplements",
    },
    {
      brand: "Protein 12 gm + Carbohydrate 7 gm + Fat 0.9 gm +Vitamins and Mineral",
      form: "Pregnant & Lactang Women Supplements",
    },

],
  },
{
  category: "Men's Health",
  items: [
    {
      brand: "Protein 0 gm + Carbohydrate 7.5 gm + Fat 0.05 gm + Sodium 80 mg + L-Arginine 1000 mg + Caffeine 100 mg + Ashwagandha KSM-66 500 mg ",
      form: "Men's Health",
    },

    ],
 },
{
  category: "Hydration",
  items: [
    {
      brand: "Sucrose 18 gm + Dextrose 16 gm + Vitamin C 50 mg + Zinc 7.5 mg",
      form: "Hydration",
    },

    ],
  }, 

{
  category: "Prework Out Supplement",
  items: [
    {
      brand: "L-Tyrosine 500 mg + L-Citrulline 3000 mg + L-Leucine 1500 mg + L-Isoleucine 750 mg + L-Valine 750 mg +Beta Alanine 500 mg + Caffeine 200 mg +Taurine 500 mg + L-Arginine 500 mg",
      form: "Prework Out Supplement",
    },
    {
      brand: "L-Citrulline 3000 mg + Creane 1000 mg + Beta Alanine 500 mg + Threonine 500 mg + Taurine 500 mg + L-Arginine 500 mg + L-Tyrosine 500 mg + Caffeine 200 mg + Niacin 18 mg + Piperine 20 mg",
      form: "Prework Out Supplement",
    },
    {
      brand: "Creane Monohydrate 3 gm",
      form: "Prework Out Supplement",
    },

    ],
  },

  {
  category: "During Workout Supplement",
  items: [
    {
      brand: "Sodium 440 mg + Potassium 200 mg + Magnesium 60 mg + Chloride 90 mg + Vitamin B1 0.7 mg + Vitamin B2 1 mg +Vitamin B3 7 mg + Vitamin B12 2.2 mcg + Vitamin C 40 mg + Vitamin D3 300 IU",
      form: "During Workout Supplement",
    },
    

    ],
  },
    {
  category: "Post Workout Recovery Supplement",
  items: [
    {
      brand: "L- Glutamine 2500 mg + Vitamin B6 0.64 mg + Vitamin C 80 mg + Sodium 220 mg + Potassium180 mg + L-Leucine 3500 mg + L-Isoleucine1750 mg + L-Valine 1750 mg + L-Citrulline 555 mg",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "L-Leucine 2.50 gm+ L-Isoleucine 1.25 gm + L-Valine Powder 1.25 gm",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "Leucine 2.7 gm + Lysine 1.2 gm + Isoleucine 0.75 gm + Valine 0.7 gm + Threonine 0.71 gm + Phenylalanine 0.5 gm + Methionine 0.3 gm +Citrulline 0.9 gm + Hisdine 107.3 mg",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "L- Glutamine 5 gm",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "Pure Whey protein Isolate 27.00 g/30 g",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "Pure Pea protein Isolate 25.50 g/30 g",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "Protein 24 gm+ Carbohydrate 1.5 gm + Fat 2 g + Glutamine 0.6 gm",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "Protein 72 gm + Carbohydrate 5 gm +Fat 6.03 g+ Glutamine 2 gm",
      form: "Post Workout Recovery Supplement",
    },
    {
      brand: "Protein 15 gm + Carbohydrate 69 gm + Fat 1.8 gm + Vitamins and Minerals + Creane Monohydrate- 1.5 gm",
      form: "Post Workout Recovery Supplement",
    },
    
    

    ],
  },

  {
  category: "Powder",
  items: [
    {
      brand: "Protein 25 g + Carbohydrate 3.6 g + fat 1.3 g + Herbs (Ashwagandha + Turmeric + Green Tea)",
      form: "Powder",
    },
    {
      brand: "Marine Collagen 7 gm + Vitamin C 65 mg + Bion 5 mcg",
      form: "Powder",
    },
  
    ],
  },

  {
  category: "Weight Management",
  items: [
    {
      brand: "Protein 6 gm + Carbohydrate 18 gm + Fat 1.5 gm + Crane Monohydrate 0.9 gm + Dietary Fiber 0.9 gm + Vitamins and Minerals",
      form: "Weight Management",
    },
    {
      brand: "Protein 21 gm + Carbohydrate 15 gm + Fat 0.5 gm + Tea Extract 500 mg + Vitamins and Minerals",
      form: "Weight Management",
    },

    ],
  },

    {
  category: "Meal Replacement",
  items: [
    {
      brand: "Protein 9.6 gm + Carbohydrates 10 gm + Fat 1.4 gm + Alpha - Linolenic Acid 0.7 gm + Zingiber Officinale Root Powder 20 mg + Vitamins And Minerals",
      form: "Meal Replacement",
    },
    {
      brand: "Protein 9.6 gm +Carbohydrate 14 gm + Fat 0.4 gm + Vitamins and Minerals",
      form: "Meal Replacement",
    },
    {
      brand: "Protein 5 gm + Carbohydrate 0.8 gm + Fat 0.06 gm",
      form: "Meal Replacement",
    },
    {
      brand: "Protein 10 gm + Carbohydrate 17 gm + Fat 0.56 gm + Calcium 154 mg + Vitamin D3 98 IU + Curcuma longa extract (Turmeric) 2.8 mg",
      form: "Meal Replacement",
    },
    {
      brand: "Coffee bean extract 100 mg + Piper nigrum L.20 mg+ Zingiber officinal rosc. 100 mg + Caffeine 50 mg",
      form: "Meal Replacement",
    },
    {
      brand: "Coffee bean extract 100 mg + Piper nigrum L. 20 mg+Taurine 200 + Zingiber officinal rosc. 100 mg + Caffeine 1.2 mg",
      form: "Meal Replacement",
    },
    
    ],
  },

  {
  category: "Kids Powder",
  items: [
    {
      brand: "Protein 10 gm + Carbohydrate 6 gm +Fat 1.54 gm +Aspargus racemous (Shatavari) extract 90 mg + Saraca Ashoka 90 mg + Curcumin 30 mg + Tinospora Cordifolia (Guduchi) 60 mg + Black Pepper 60 mg + Vitamins and Minerals",
      form: "Kids Powder",
    },
    {
      brand: "Protein 35 % 4.50 g + Carbohydrate 24 gm + fat 10 % 6 gm+ DHA 30 mg +Taurine 9 mg + Inositol 12 mg + Lactobaccillus acidofillus 30 Billion cfu + Bifidobacterium Spp. 30 Billion cfu + Vitamins + Mineralss",
      form: "Kids Powder",
    },
    {
      brand: "Protein 6 gm + Carbohydrate 12 gm + Fat 0.66 gm +Vitamins and Minerals",
      form: "Kids Powder",
    },
    {
      brand: "Protein 4 gm + Carbohydrate 15 gm + Fat 1.7 gm + Fibers 0.50 gm + DHA 20 mg + Bacopa monnieri (Brahmi) leaf Extract 125 mg + Convolvulus pluricaulis (Shankhpushpi) seed Extract 125 mg + Curcuma longa (Curcumin) rhizome Extract 25 mg + Probioc blend 15 Billion cfu + Fructo - Oligosachharides 0.50 mg",
      form: "Kids Powder",
    },
    {
      brand: "Dextrose 17 gm + Sucrose 16 g + Zinc 16 g + Vitamin C 12 mg + Vitamin C 40 mg + Potassium Chloride 300 mg + Lactobaccilus Acidophillus 100 CFU",
      form: "Kids Powder",
    },
    {
      brand: "Protein 15 gm + Carbohydrate 9 gm + Fat 0.3 gm",
      form: "Kids Powder",
    },
    {
      brand: "Protein 10 gm + Carbohydrate 22 gm + Fat 5 gm + Vitamins and Minerals",
      form: "Kids Powder",
    },
    
    ],
  },


],

    "Mouth Dissolving Sachets": [


{
  category: "Women's Nutrition",
  items: [
    {
      brand: "Cranberry Extract 150 mg + D-mannose 125 mg + Lactobacillus crispatus, Lactobacillus rhamnosus,Lactobacillus gasseri, Lactobacillus jensenii (6 Billion CFU) + Vitamin C 65 mg + Inulin 50 mg and Zinc gluconate 10 mg",
      form: "Women's Nutrition",
    },
    {
      brand: "Myo – Inositol 2000 mg + Vitamin C 65 mg + D-Chiro-inositol 50 mg + Inulin 50 mg + Vitamin D2 600IU + Vitamin B3 11mg + Vitamin B5 5 mg + Vitamin B2 1.9 mg + Vitamin B6 2 mg + Chromium picolinate 200 mcg + Vitamin B7 30 mcg + Vitamin B12 2.5 mcg + Lactobacillus acidophillus, Lactobacillus reteuri, Lactobacillus fermentum and Bifidobacterium longum (10 Billion CFU)",
      form: "Women's Nutrition",
    },

    
    ],
  }, 


    {
  category: "Sleep Health",
  items: [
    {
      brand: "Magnesium gluconate 100mg + L-theanine 100mg + Inulin 50mg + Melatonin 5mg + Lactobacillus reuturi 4 billion CFU",
      form: "Sleep Health",
    },
   

    ],
  },

  {
  category: "Immunity Booster",
  items: [
    {
      brand: "Lactobacillus rhamnosus GG - (ATCC 53103) 6 Billion CFU",
      form: "Immunity Booster",
    },
    {
      brand: "Vitamin C 40 mg + Inulin 100 mg + Vitamin D2 (Ergocalciferol) 400 IU + Lactobacillus rhamnosus GG - 6 Billion CFU",
      form: "Immunity Booster",
    },
    {
      brand: "Vitamin C 40 mg + Inulin + Zinc gluconate 10 mg + Vitamin D2 400 IU + Lactobacillus rhamnosus GG 6 Billion CFU",
      form: "Immunity Booster",
    },

    ],
  },

    {
    category: "Skin Care",
    items: [
      {
        brand: "Glutathione 500 mg + Lactobacillus planterum 6 billion Cells + Vitamin C 65mg mg + Inulin 50 mg + Trans-Resveratrol from Grapes 50 mg + Zinc gluconate 10 mg + Lycopene 6 mg + Vitamin E 500 mcg + Bion 30 mcg",
        form: "Skin Care",
      },
    

      ],
    },
    {
    category: "Bloating & Focus",
    items: [
      {
        brand: "Organic Inulin 50 mg + Fructooligosaccharides 200 mg + Peppermint extract 30 mg and Bifidobacterium longum 3 Billion CFU",
        form: "Bloating & Focus",
      },
      {
        brand: "Caffeine 80 mg + L-theanine 60 mg + L-Tyrosine 300 mg + Taurine 200 mg + Vitamin B6 2 mg + Vitamin B12 1 mcg",
        form: "Bloating & Focus",
      },
    

      ],
    },



],

  };



  const activeCategory = data[activeCard]?.title;
  const activeSEOData = data[activeCard];
  const sections = useMemo(() => tableData[activeCategory] || [], [activeCategory]);

  // 🔗 Sync URL /products/:slug  →  activeCard
  useEffect(() => {
    if (!routeSlug) return;
    const matchIndex = data.findIndex(
      (item) => slugify(item.title) === routeSlug.toLowerCase()
    );
    if (matchIndex !== -1 && matchIndex !== activeCard) {
      setActiveCard(matchIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeSlug]);

  // 🔗 Sync activeCard  →  URL /products/:slug
  const handleCardClick = (index) => {
    setActiveCard(index);
    const slug = slugify(data[index]?.title);
    if (slug) {
      navigate(`/products/${slug}`);
    }
  };

  // Update document title and meta description when active card changes
  useEffect(() => {
    if (activeSEOData) {
      // Update page title
      document.title = activeSEOData.seoTitle || `${activeSEOData.title} | NutraLike`;
      
      // Update or create meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = activeSEOData.seoDescription;
      
      // Update or create meta keywords
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = activeSEOData.metaKeywords;
      
      // Update canonical URL (optional)
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = `${window.location.origin}/products/${slugify(activeSEOData.title)}`;
      
      // Update Open Graph tags for social media
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.content = activeSEOData.seoTitle;
      
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.content = activeSEOData.seoDescription;
    }
    // ── OG Image ──────────────────────────────────────────
let ogImage = document.querySelector('meta[property="og:image"]');
if (!ogImage) {
  ogImage = document.createElement('meta');
  ogImage.setAttribute('property', 'og:image');
  document.head.appendChild(ogImage);
}
ogImage.content = activeSEOData.ogImage || "https://yourdomain.com/images/default-og.jpg";

let ogImageWidth = document.querySelector('meta[property="og:image:width"]');
if (!ogImageWidth) {
  ogImageWidth = document.createElement('meta');
  ogImageWidth.setAttribute('property', 'og:image:width');
  document.head.appendChild(ogImageWidth);
}
ogImageWidth.content = "1200";

let ogImageHeight = document.querySelector('meta[property="og:image:height"]');
if (!ogImageHeight) {
  ogImageHeight = document.createElement('meta');
  ogImageHeight.setAttribute('property', 'og:image:height');
  document.head.appendChild(ogImageHeight);
}
ogImageHeight.content = "630";

// ── Twitter Card ───────────────────────────────────────
const twitterTags = {
  "twitter:card": "summary_large_image",
  "twitter:title": activeSEOData.seoTitle,
  "twitter:description": activeSEOData.seoDescription,
  "twitter:image": activeSEOData.ogImage || "https://yourdomain.com/images/default-og.jpg",
};

Object.entries(twitterTags).forEach(([name, content]) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = name;
    document.head.appendChild(tag);
  }
  tag.content = content;
});
    
    // Cleanup function (optional - for SPA navigation)
    return () => {
      // Reset to default when component unmounts (optional)
      // document.title = "NutraLike - Premium Nutritional Supplements";
    };
  }, [activeCard, activeSEOData]);

  // 🔥 SEARCH FUNCTIONALITY
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSections(sections);
      return;
    }

    const searchLower = searchTerm.toLowerCase().trim();
    
    const filtered = sections
      .map((section) => {
        const filteredItems = section.items.filter(
          (item) =>
            item.brand.toLowerCase().includes(searchLower) ||
            item.form.toLowerCase().includes(searchLower)
        );
        
        if (filteredItems.length > 0) {
          return {
            ...section,
            items: filteredItems,
          };
        }
        return null;
      })
      .filter(Boolean);

    setFilteredSections(filtered);
  }, [searchTerm, sections]);

  // Reset search when active category changes
  useEffect(() => {
    setSearchTerm("");
    setFilteredSections(sections);
  }, [activeCategory]);

  const clearSearch = () => {
    setSearchTerm("");
  };

  const getSearchResultCount = () => {
    if (!searchTerm.trim()) return null;
    let totalItems = 0;
    filteredSections.forEach(section => {
      totalItems += section.items.length;
    });
    return totalItems;
  };

  const resultCount = getSearchResultCount();

  // Schema markup for current product
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": activeSEOData?.title,
  "description": activeSEOData?.seoDescription,
  "image": activeSEOData?.img,

  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": window.location.href
  }
};

  return (
    <>
      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>

{/* 🔥 TOP SECTION */}
<div className="py-10 sm:py-14 container max-w-7xl mx-auto px-4 sm:px-6 rounded-b-[40px]">

  {/* SEO-optimized heading for current active product */}
  <h1
    className="
      text-3xl sm:text-4xl md:text-3xl lg:text-4xl
      font-serif
      leading-tight
      text-[#355931]
      mb-5
    "
  >
    {activeSEOData?.seoTitle || "Our Products"}{" "}
    
    <span className="bg-gradient-to-r from-[#355931] via-[#4f7c45] to-[#7aa96b] bg-clip-text text-transparent">
      Collection
    </span>
  </h1>

  {/* SEO-optimized description for current active product */}
  <div className="max-w-6xl mb-8 sm:mb-10">
    <p
      className="
        text-[#4b5563]
        leading-relaxed
        text-sm sm:text-base md:text-lg
        font-normal
      "
    >
      {activeSEOData?.longDescription ||
        activeSEOData?.seoDescription ||
        "Nutra Like products are carefully formulated to support overall health, wellness, and daily nutritional needs. Designed with high-quality ingredients, these supplements help improve immunity, energy levels, and skin health while promoting a balanced lifestyle. Each product goes through strict quality checks to ensure safety, effectiveness, and consistency. Nutra Like focuses on combining essential vitamins, minerals, and antioxidants to deliver maximum benefits for modern lifestyles."}
    </p>
  </div>
        {/* 🔥 SLIDER */}
        <div className="relative overflow-hidden">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            loop={true}
            spaceBetween={10}
            slidesPerView={2}
            centeredSlides={false}
            breakpoints={{
              480: { slidesPerView: 2, spaceBetween: 12 },
              640: { slidesPerView: 3, spaceBetween: 16 },
              768: { slidesPerView: 4, spaceBetween: 18 },
              1024: { slidesPerView: 6, spaceBetween: 20 },
            }}
            className="!overflow-hidden"
          >
            {data.map((item, index) => {
              const isActive = index === activeCard;

              return (
                <SwiperSlide key={index} className="h-auto">
                  <div
                    onClick={() => handleCardClick(index)}
                    role="button"
                    tabIndex={0}
                    aria-label={`View ${item.title}`}
                    className={`cursor-pointer rounded-xl overflow-hidden bg-white border transition-all duration-300 h-full flex flex-col
                      ${isActive
                        ? "border-[#355931] shadow-md"
                        : "border-gray-200 hover:border-[#355931]/40"
                      }`}
                  >
                    {/* Image */}
                    <div
                      className="flex items-center justify-center overflow-hidden p-2 sm:p-3 md:p-4 h-24 sm:h-28 md:h-32 lg:h-36"
                    >
                      <img
                        src={item.img}
                        alt={item.title}
                        className="max-w-full max-h-full w-auto h-auto object-contain"
                        loading="lazy"
                      />
                    </div>

                    {/* Content */}
                    <div className="relative bg-white px-2 py-2 sm:px-3 sm:py-3 mt-auto">
                      {/* Top Accent */}
                      <div
                        className={`absolute top-0 left-0 w-full h-1
                          ${isActive ? "bg-[#355931]" : "bg-gray-200"}
                        `}
                      ></div>

                      {/* Title */}
                      <h3
                        className={`mt-1 text-center font-medium leading-snug break-words
                          text-xs sm:text-sm md:text-base
                          ${isActive ? "text-[#355931]" : "text-gray-700"}
                        `}
                      >
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/* 🔥 NAVIGATION */}
        <div className="flex gap-3 sm:gap-4 mt-4 sm:mt-6">
          <button
            onClick={() => swiperRef.current?.slidePrev()}
            className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center border border-[#355931] text-[#355931] rounded-full hover:bg-[#355931] hover:text-white transition-colors"
            aria-label="Previous product"
          >
            <ArrowLeft size={16} className="sm:w-[18px] sm:h-[18px]" />
          </button>

          <button
            onClick={() => swiperRef.current?.slideNext()}
            className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center border border-[#355931] text-[#355931] rounded-full hover:bg-[#355931] hover:text-white transition-colors"
            aria-label="Next product"
          >
            <ArrowRight size={16} className="sm:w-[18px] sm:h-[18px]" />
          </button>
        </div>
      </div>

      {/* 🔥 TABLE SECTION WITH SEARCH */}
      <div className="bg-[#F2F6EF]">
        {/* HEADER */}
        <div className="overflow-hidden">
          <div className="bg-gradient-to-r from-[#355931] to-[#1f3d1f] text-white py-6 sm:py-8">
            <div className="container max-w-7xl mx-auto px-4 sm:px-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-6">
                <h2 className="text-xl sm:text-2xl font-semibold border-l-4 border-white pl-3">
                  {activeCategory || "Our Products"} - Complete Product Range
                </h2>

                {/* Search Box */}
                <div className="relative w-full sm:w-80">
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 sm:w-5 sm:h-5" />
                    <input
                      type="text"
                      placeholder="Search Brand, Drug, Dosage..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full bg-white/10 border border-white/30 rounded-full pl-10 pr-10 py-2 text-white placeholder:text-gray-300 text-xs sm:text-sm outline-none focus:bg-white/20 focus:border-white/50 transition-all duration-300"
                      aria-label="Search products"
                    />
                    {searchTerm && (
                      <button
                        onClick={clearSearch}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-white transition-colors"
                        aria-label="Clear search"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                  
                  {searchTerm && (
                    <div className="absolute right-0 -bottom-6 text-xs text-white/70">
                      {resultCount === 0 ? (
                        <span>No results found</span>
                      ) : (
                        <span>{resultCount} result{resultCount !== 1 ? 's' : ''} found</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* TABLE CONTENT */}
        <div className="bg-[#F2F6EF] py-8 sm:py-10 rounded-b-3xl max-w-7xl mx-auto px-4 sm:px-6">
          <div className="space-y-8 sm:space-y-10">
            {filteredSections.length > 0 ? (
              filteredSections.map((section, i) => (
                <div key={i}>
                  <h3 className="flex items-center gap-2 sm:gap-3 text-lg sm:text-xl font-semibold text-[#355931] mb-3 sm:mb-4">
                    <StepForward className="w-5 h-5 sm:w-7 sm:h-7 text-[#355931]" />
                    {section.category}
                    {searchTerm && (
                      <span className="text-xs sm:text-sm font-normal text-gray-500 ml-2">
                        ({section.items.length})
                      </span>
                    )}
                  </h3>

                  <div className="overflow-x-auto rounded-2xl shadow-sm">
                    <div className="min-w-[300px]">
                      {/* Header */}
                      <div className="grid grid-cols-2 bg-[#355931] text-white px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm font-medium">
                        <div>Composition</div>
                        <div className="text-right">Indication</div>
                      </div>

                      {/* Rows */}
                      {section.items.map((item, idx) => (
                        <div
                          key={idx}
                          className="grid grid-cols-2 px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm bg-white border-b last:border-none hover:bg-gray-50 transition-colors duration-200"
                        >
                          <div className="text-gray-800 break-words pr-2 font-medium">
                            {item.brand}
                          </div>
                          <div className="text-gray-600 text-right break-words pl-2">
                            {item.form}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-12 sm:py-16 bg-white rounded-2xl">
                {searchTerm ? (
                  <>
                    <div className="text-6xl mb-4">🔍</div>
                    <h3 className="text-lg sm:text-xl font-semibold text-gray-700 mb-2">
                      No results found
                    </h3>
                    <p className="text-gray-500 text-sm sm:text-base">
                      No products matching "{searchTerm}" were found
                    </p>
                    <button
                      onClick={clearSearch}
                      className="mt-4 px-4 py-2 bg-[#355931] text-white rounded-full text-sm hover:bg-[#2a4727] transition-colors"
                    >
                      Clear Search
                    </button>
                  </>
                ) : (
                  <>
                    <div className="text-6xl mb-4">📦</div>
                    <h3 className="text-lg sm:text-xl font-semibold text-gray-700 mb-2">
                      No Products Available
                    </h3>
                    <p className="text-gray-500 text-sm sm:text-base">
                      Select a product category from the slider above
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPage_New;